import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Download, EyeOff, ImageDown } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "");

// Visuels terminés que l'écran n'a jamais reçus (page quittée, ou « Interrompu » affiché à tort).
export const RecoveredVisuals = () => {
  const [jobs, setJobs] = useState([]);
  useEffect(() => { api.get("/images/recovered").then((r) => setJobs(r.data || [])).catch(() => {}); }, []);
  if (!jobs.length) return null;
  const dismiss = async (id) => {
    await api.post(`/images/recovered/${id}/dismiss`).catch(() => {});
    setJobs((all) => all.filter((j) => j.id !== id));
  };
  const dismissAll = () => jobs.forEach((j) => dismiss(j.id));
  return (
    <section className="mb-8 border border-emerald-200 bg-emerald-50/60 rounded-sm p-5" data-testid="recovered-visuals">
      <div className="flex items-start justify-between gap-3">
        <p className="flex items-center gap-2 text-sm font-semibold text-emerald-900"><ImageDown className="h-4 w-4" /> Vos visuels terminés vous attendent</p>
        {jobs.length > 1 && <button onClick={dismissAll} data-testid="recovered-dismiss-all" className="shrink-0 text-xs font-semibold text-slate-500 hover:text-slate-800">Tout masquer</button>}
      </div>
      <p className="text-xs text-emerald-800 mt-1 mb-4">Ces visuels ont bien été créés, mais ne s'étaient pas affichés à l'écran. Téléchargez-les ou masquez-les.</p>
      <div className="space-y-4">
        {jobs.map((j) => (
          <div key={j.id} className="bg-white border border-emerald-100 rounded-sm p-3" data-testid={`recovered-job-${j.id}`}>
            <div className="flex items-start justify-between gap-3 mb-2">
              <p className="text-xs text-slate-600 line-clamp-2"><span className="font-semibold text-slate-800">{fmt(j.created_at)}</span> · {j.post_excerpt}</p>
              <button onClick={() => dismiss(j.id)} data-testid={`recovered-dismiss-${j.id}`} className="shrink-0 inline-flex items-center gap-1 text-xs font-semibold text-slate-500 hover:text-slate-800"><EyeOff className="h-3.5 w-3.5" /> Masquer</button>
            </div>
            <div className="flex gap-3 flex-wrap">
              {j.images.map((src, k) => (
                <a key={k} href={src} download={`visuel-${j.id}-${k + 1}.jpg`} data-testid={`recovered-download-${j.id}-${k}`} className="group relative block w-40">
                  <img src={src} alt={`Visuel ${k + 1}`} className="w-40 rounded-sm border border-slate-200" />
                  <span className="absolute bottom-1 right-1 inline-flex items-center gap-1 bg-white/90 text-[10px] font-semibold px-1.5 py-0.5 rounded-sm opacity-80 group-hover:opacity-100"><Download className="h-3 w-3" /> Télécharger</span>
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RecoveredVisuals;
